<article class="bn-care-plan-item-card">
  <div class="bn-care-plan-item-card__main">
    <ng-content select="[carePlanCardMain]" />
  </div>
  <div class="bn-care-plan-item-card__actions">
    <ng-content select="[carePlanCardActions]" />
  </div>
</article>
